import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { PopoverInput } from './base/popover-input';

@Component({
	selector: 'popover-editable-number',
	template: require('./popover-number.component.html')

})
export class PopoverNumberComponent extends PopoverInput {

	constructor() { super() }

	isNumber(val) { return typeof val === 'number'; }

	@Input() kind: "" | "decimal" | "decimal-0" | "percentage" = "";

	@Input() suffix: "" | "month" | "day" | "m2";

	@Input() negate: boolean = false;

	@Input() numberPipeFormat: string = "1.2-2";

	valueChanged(): void {
		if (this.originalValue != null && this.kind === "percentage") {
			this.dirtyValue = +(this.originalValue * 100).toFixed(2);
		} else {
			this.dirtyValue = this.originalValue;
		}
	}

	ngOnChanges(changes: SimpleChanges) {

		if (changes['kind']) {
			this.valueChanged();
		}
	}

	onCancel() {
		if (this.kind === "percentage") {
			this.dirtyValue = +(this.originalValue * 100).toFixed(2);
		} else {
			this.dirtyValue = this.originalValue;
		}
	}

	onSave(event: any): void {

		this.changeCallback.emit({
			id: this.id,
			newValue: this.dirtyValue == null ? this.dirtyValue : this.dirtyValue / (this.kind === "percentage" ? 100 : 1),
			oldValue: this.originalValue,
			resolve: () => {
				this.originalValue = this.dirtyValue == null ? null : this.dirtyValue / (this.kind === "percentage" ? 100 : 1);
				event.resolve();
			}
			,
			reject: (response: string) => {
				event.reject(response);
			}
		});
	}

	get pluralizedSuffix() {

		if (this.suffix === "")
			return "";

		var isSingular = Math.abs(Number(this.originalValue)) === 1;

		if (this.suffix === "m2") {
			return "m<sup>2</sup>";
		}

		if (this.suffix === "month") {
			return isSingular ? "month" : "months";
		}

		else if (this.suffix === "day") {
			return isSingular ? "day" : "days";
		}

		return this.suffix;
	}


	get displayValue(): any {

		if (this.negate && this.isNumber(this.originalValue)) {
			return (-1 * Number(this.originalValue)).toString();
		}

		return this.originalValue;
	}

	get hasChanges() { return this.originalValue * (this.kind === "percentage" ? 100 : 1) !== this.dirtyValue; }

}




// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover-number.component.ts